module.exports = __webpack_public_path__ + "80dfc0ec0281575c286121bd3d743b38.svg";